import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatProgressBar } from '@angular/material/progress-bar'
import { responseDefaultForm } from '../../../../shared/utils/utils'
import { PersonDocumentService } from '../../../../core/services/person/person-document/person-document.service'
import { ContractUploadCreateFormComponent } from './contract-upload-create-form/contract-upload-create-form.component'
import { downloadBase64File } from '../../../../shared/utils/download_base64'
import { MatSelectModule } from '@angular/material/select'
import { MatNativeDateModule } from '@angular/material/core'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { NgxMaskDirective } from 'ngx-mask'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { ContractUploadEditFormComponent } from './contract-upload-edit copy/contract-upload-edit-form.component'
import { ContractClientService } from '../../../../core/services/contract/contract-client/contract-client.service'

@Component({
  selector: 'contract-upload',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatCard,
    MatIconModule,
    MatCardHeader,
    MatCardTitle,
    MatAccordion,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatColumnDef,
    MatSelectModule,
    MatProgressBar,
    MatPaginator,
    MatTableModule,
  ],
  templateUrl: './contract-upload.component.html',
  styleUrl: './contract-upload.component.scss',
  providers: [PersonDocumentService],
  standalone: true,
})
export class ContractUploadComponent implements OnInit, AfterViewInit {
  constructor(
    private personDocumentService: PersonDocumentService,
    private contractClientService: ContractClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ContractUploadComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  item: any = {}
  loading: boolean = true

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idPerson: number = 0
  @Input() idCliente: any = ''
  @Input() idContrato: any = ''
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'documentType',
      key: 'tipoDocDescricao',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'file',
      key: 'nomeArquivo',
      description: 'Arquivo',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['description', 'file', 'documentType', 'action']

  tableDocuments: MatTableDataSource<any> = new MatTableDataSource<any>()

  columnsDocuments = [
    // { keyColumn: 'tipo', key: 'tipo', description: 'Tipo' },
    { keyColumn: 'description', key: 'descricao', description: 'Descrição' },
    { keyColumn: 'file', key: 'nomeArquivo', description: 'Arquivo' },
    { keyColumn: 'action', key: 'action', description: 'Ações' },
  ]

  totalDocuments: number = 0

  documents: any[] = []

  displayedColumnsDocuments = [
    // 'tipo',
    'description',
    'file',
    'action']

  clientSelected: any = {}
  selectedFiles: File[] = []

  listSearch: any = [
    {
      id: 'tipoContatoId',
      description: 'Tipo Contato',
      type: 'number',
      visible: false,
    },
    {
      id: 'descricao',
      description: 'Descrição',
      type: 'string',
      visible: true,
    },
  ]

  searchForm: any = { search: false, model: {} }
  inputSearchContact: any = { type: '', search: '' }

  ngOnInit(): void {
    console.log('contrato: ', this.idContrato)
    //this.getContactByPerson()
    this.loadDocuments()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    this.loadDocuments()
  }

  getContactByPerson() {
    this.loading = true
    // this.personDocumentService.listPersonDocumentbyId(this.idPerson).subscribe({
    this.contractClientService
      .listPagedFileContractClient(this.page, this.rows, this.idContrato)
      // this.personDocumentService
      //   .listPagedPersonDocumentById(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  uploadFiles() {
    const dialogRef = this.dialog.open(ContractUploadCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
        idContrato: this.idContrato,
        pessoaId: this.idCliente,
      },
    })
    dialogRef.componentInstance.response.subscribe((event) =>
      this.responseForm(event),
    )

    // Limpa a lista após upload
    this.selectedFiles = []
  }

  editDocument(doc: any) {
    const dialogRef = this.dialog.open(ContractUploadEditFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: doc,
        idContrato: this.idContrato,
        pessoaId: this.idCliente,
      },
    })
    dialogRef.componentInstance.response.subscribe((event) =>
      this.responseForm(event),
    )
    console.log('Editar documento:', doc)
  }

  downloadDocument(doc: any) {
    if (!doc || !doc.id) return
    this.contractClientService.downloadFileContractClient(doc.id).subscribe({
      // this.personDocumentService.downloadPersonDocument(doc.id).subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.fileContent,
          response.fileName,
          response.type,
        )
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
      },
      complete: () => {},
    })
  }

  deleteDocument(doc: any) {
    if (!doc || !doc.id) return
    this.loading = true
    this.contractClientService
      .deleteFileContractClient(doc.id)
      // this.personDocumentService
      //   .deletePersonDocument(doc.id, { id: doc.id })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(
            response.message || 'Documento excluído com sucesso!',
          )
        },
        error: (err: any) => {
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
          this.loadDocuments() // Atualiza a lista após deletar
        },
      })
    // Lógica para deletar o documento (confirmar e chamar API)
    // console.log('Deletar documento:', doc);
  }

  loadDocuments() {
    this.loading = true
    // this.personDocumentService
    //   .listPagedPersonDocumentById(this.idCliente, this.page, this.rows)
    this.contractClientService
      .listPagedFileContractClient(this.page, this.rows, this.idContrato)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          const items = response.data?.items ?? response.data ?? []
          this.documents = items
          this.totalDocuments = response.data?.total ?? items.length
          this.tableDocuments = new MatTableDataSource<any>(this.documents)
          this.loading = false
          console.log('Dados:', this.data.clientePessoaId, this.rows, this.page)
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
      })
  }

  onPageChange(page: number) {
    this.page = page
    this.loadDocuments()
  }

  searchContact() {
    this.loading = true
    this.personDocumentService
      .searchPagedPersonDocument(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  downloadItem(element: any) {
    this.personDocumentService.downloadPersonDocument(element.id).subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.fileContent,
          response.fileName,
          response.type,
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.personDocumentService
      .deletePersonDocument(element.id, { id: element.id })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.clearItem()
          this.uploadList()
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.success(err.message)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
